import React from 'react';


const Card = (props) => {
    return (
        <div className="card card-design ">
            <div className="card-body row">

                <div className="col-9 ">
                    <p className="card-text">{props.heading}</p>
                    <h5 className="card-title">{props.body}</h5>
                </div>
                <div className="col-3 icon">
                    <i className={props.icon}></i>
                </div>
            </div>
        </div>
    );
}
export default Card;